import { SoapUtils } from '../../../../utils/SoapUtils';
import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IListEventRequest extends IBaseRequest {
    userFilter?:         number;
    orderBy1Desc?:       string;
    orderBy1Field?:      string;
    orderBy2Desc?:       string;
    orderBy2Field?:      string;
    orderBy3Desc?:       string;
    orderBy3Field?:      string;
    orderBy4Desc?:       string;
    orderBy4Field?:      string;
    anyTime?:            number;
    standardStatus?:     number;
    entryType?:          string;
    activityId?:         number;
    projectId?:          number;
    folderId?:           number;
    approvalStatus?:     string;
    chargeable?:         string;
    uid?:                string;
    limit?:              number;
    offset?:             number;
    dateOfInterest?:     number;
    rangeEnd?:           Date;
    rangeStart?:         Date;
    solutionStatus?:     string;
    groupUsers?:         number;
    userId?:             number;
    recordId?:           string;
    resourceId?:         string;
    refid?:              string;
    dependend?:          string;
    plannedTaskCurrent?: string;
    dimension1?:         string;
    dimension2?:         string;
    dimension3?:         string;
    USER?:               EventUser[];
    RESOURCE?:           Resource[];
}

export interface EventUser {
    id: string;
}

function toEventUserXml(user: EventUser): string {
    return `<USER><id>${user.id}</id></USER>`;
}

export interface Resource {
    id?:           string;
    name?:         string;
    description?:  string;
    categoryId?:   string;
    needApproval?: string;
}

function toResourceXml(resource: Resource): string {
    var xml = '<RESOURCE>';
    xml += SoapUtils.makeNode(resource.id, 'id');
    xml += SoapUtils.makeNode(resource.name, 'name');
    xml += SoapUtils.makeNode(resource.description, 'description');
    xml += SoapUtils.makeNode(resource.categoryId, 'categoryId');
    xml += SoapUtils.makeNode(resource.needApproval, 'needApproval');
    xml += '</RESOURCE>';

    return xml;
}
export class ListEventRequest extends BaseRequest implements IListEventRequest {

    public userFilter?:         number;
    public orderBy1Desc?:       string;
    public orderBy1Field?:      string;
    public orderBy2Desc?:       string;
    public orderBy2Field?:      string;
    public orderBy3Desc?:       string;
    public orderBy3Field?:      string;
    public orderBy4Desc?:       string;
    public orderBy4Field?:      string;
    public anyTime?:            number;
    public standardStatus?:     number;
    public entryType?:          string;
    public activityId?:         number;
    public projectId?:          number;
    public folderId?:           number;
    public approvalStatus?:     string;
    public chargeable?:         string;
    public uid?:                string;
    public limit?:              number;
    public offset?:             number;
    public dateOfInterest?:     number;
    public rangeEnd?:           Date;
    public rangeStart?:         Date;
    public solutionStatus?:     string;
    public groupUsers?:         number;
    public userId?:             number;
    public recordId?:           string;
    public resourceId?:         string;
    public refid?:              string;
    public dependend?:          string;
    public plannedTaskCurrent?: string;
    public dimension1?:         string;
    public dimension2?:         string;
    public dimension3?:         string;
    public USER?:               EventUser[];
    public RESOURCE?:           Resource[];
    
    constructor(server: string, session: string, otherOptions: any) {
        super(server, session);
        this.userFilter = otherOptions.userFilter;
        this.orderBy1Desc = otherOptions.orderBy1Desc;
        this.orderBy1Field = otherOptions.orderBy1Field;
        this.orderBy2Desc = otherOptions.orderBy2Desc;
        this.orderBy2Field = otherOptions.orderBy2Field;
        this.orderBy3Desc = otherOptions.orderBy3Desc;
        this.orderBy3Field = otherOptions.orderBy3Field;
        this.orderBy4Desc = otherOptions.orderBy4Desc;
        this.orderBy4Field = otherOptions.orderBy4Field;
        this.anyTime = otherOptions.anyTime;
        this.standardStatus = otherOptions.standardStatus;
        this.entryType = otherOptions.entryType;
        this.activityId = otherOptions.activityId;
        this.projectId = otherOptions.projectId;
        this.folderId = otherOptions.folderId;
        this.approvalStatus = otherOptions.approvalStatus;
        this.chargeable = otherOptions.chargeable;
        this.uid = otherOptions.uid;
        this.limit = otherOptions.limit;
        this.offset = otherOptions.offset;
        this.dateOfInterest = otherOptions.dateOfInterest;
        this.rangeEnd = otherOptions.rangeEnd;
        this.rangeStart = otherOptions.rangeStart;
        this.solutionStatus = otherOptions.solutionStatus;
        this.groupUsers = otherOptions.groupUsers;
        this.userId = otherOptions.userId;
        this.recordId = otherOptions.recordId;
        this.resourceId = otherOptions.resourceId;
        this.refid = otherOptions.refid;
        this.dependend = otherOptions.dependend;
        this.plannedTaskCurrent = otherOptions.plannedTaskCurrent;
        this.dimension1 = otherOptions.dimension1;
        this.dimension2 = otherOptions.dimension2;
        this.dimension3 = otherOptions.dimension3;
        this.USER = otherOptions.USER;
        this.RESOURCE = otherOptions.RESOURCE;
    }

    public toXml(): string {
        var parameters: string = super.toXml();

        parameters += this.makeNode(this.userFilter, 'userFilter');
        parameters += this.makeNode(this.orderBy1Desc, 'orderBy1Desc');
        parameters += this.makeNode(this.orderBy1Field, 'orderBy1Field');
        parameters += this.makeNode(this.orderBy2Desc, 'orderBy2Desc');
        parameters += this.makeNode(this.orderBy2Field, 'orderBy2Field');
        parameters += this.makeNode(this.orderBy3Desc, 'orderBy3Desc');
        parameters += this.makeNode(this.orderBy3Field, 'orderBy3Field');
        parameters += this.makeNode(this.orderBy4Desc, 'orderBy4Desc');
        parameters += this.makeNode(this.orderBy4Field, 'orderBy4Field');
        parameters += this.makeNode(this.anyTime, 'anyTime');
        parameters += this.makeNode(this.standardStatus, 'standardStatus');
        parameters += this.makeNode(this.entryType, 'entryType');
        parameters += this.makeNode(this.activityId, 'activityId');
        parameters += this.makeNode(this.projectId, 'projectId');
        parameters += this.makeNode(this.folderId, 'folderId');
        parameters += this.makeNode(this.approvalStatus, 'approvalStatus');
        parameters += this.makeNode(this.chargeable, 'chargeable');
        parameters += this.makeNode(this.uid, 'uid');
        parameters += this.makeNode(this.limit, 'limit');
        parameters += this.makeNode(this.offset, 'offset');
        parameters += this.makeNode(this.dateOfInterest, 'dateOfInterest');
        parameters += this.makeNode(this.rangeEnd, 'rangeEnd');
        parameters += this.makeNode(this.rangeStart, 'rangeStart');
        parameters += this.makeNode(this.solutionStatus, 'solutionStatus');
        parameters += this.makeNode(this.groupUsers, 'groupUsers');
        parameters += this.makeNode(this.userId, 'userId');
        parameters += this.makeNode(this.recordId, 'recordId');
        parameters += this.makeNode(this.resourceId, 'resourceId');
        parameters += this.makeNode(this.refid, 'refid');
        parameters += this.makeNode(this.dependend, 'dependend');
        parameters += this.makeNode(this.plannedTaskCurrent, 'plannedTaskCurrent');
        parameters += this.makeNode(this.dimension1, 'dimension1');
        parameters += this.makeNode(this.dimension2, 'dimension2');
        parameters += this.makeNode(this.dimension3, 'dimension3');
        this.USER?.forEach(user => parameters += toEventUserXml(user));
        this.RESOURCE?.forEach(resource => parameters += toResourceXml(resource));

        return super.wrapperXml('ListEvent', parameters);
    }
}
